///<reference types="vite-plugin-svgr/client" />
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { FeatheryProvider } from '@/features/feathery/FeatheryProvider';
import { LocalStorageVariables } from '@/enums/LocalStorageVariables';
import { router } from '@/routes/router';
import { store } from '@/store/store';
import { theme } from '@/styles/theme/theme';
import './index.css';
import './polyfills/pdf-viewer';
import packageJson from '../package.json';

localStorage.setItem(LocalStorageVariables.ApiBaseUrl, import.meta.env.VITE_API_URL);

// eslint-disable-next-line no-console
console.log(
  `%cApp Version ➜ ${packageJson.version}`,
  'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
  {
    env_variables: JSON.parse(import.meta.env.VITE_EDS_DEBUG) ? import.meta.env : {},
  },
);

dayjs.extend(utc);

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <FeatheryProvider>
        <CssBaseline />
        <RouterProvider router={router} />
      </FeatheryProvider>
    </ThemeProvider>
  </Provider>,
);
